/* eslint-disable no-template-curly-in-string  */
/* eslint-disable no-console  */
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'connected-react-router';
import { Provider, useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { configManager } from '@unicus/react-ui-kit';
import { authInitialState } from 'core/auth/authInitialState';
import config from 'config';
import Iugu from 'util/iugu';
import rootStore from './stores/rootStore';
import Main from './Main';

import 'moment/locale/pt-br';

configManager.setConfig({
  apiUrl: process.env.REACT_APP_API_URL,
  memedUrl: process.env.REACT_APP_MEMED_SERVER_URL,
  multiTenant: { enabled: false, host: 'a' },
  iuguAccountId: process.env.REACT_APP_IUGU_ID,
  isTestMode: process.env.REACT_APP_IUGU_DEVELOPMENT === 'true',
  layout: {
    form: {
      layout: 'vertical',
      labelCol: null,
      wrapperCol: null,
      validateMessages: {
        pattern: {
          mismatch: '${label} é inválido'
        }
      }
    },
    list: { table: { size: 'middle' } }
  },
  roles: config.roles,
  map: {
    token:
      'pk.eyJ1IjoiZGV2dW5pY3VzIiwiYSI6ImNrbDZtam9qaDFrYmcycGxjanpuMTBzbXAifQ.OCfiXk8HWMf2IigIPeLJvQ'
  }
});

const initialState = {
  resources: [],
  auth: authInitialState
};

const settings = configManager.getConfig();

try {
  Iugu.setAccountID(settings.iuguAccountId);
  Iugu.setTestMode(settings.isTestMode);
} catch (error) {
  console.log(error);
}

const history = createBrowserHistory();
const store = rootStore(initialState, history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route component={Main} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
